import React, { useState, useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const infoSections = [
  {
    id: 'taste',
    icon: 'images/mpmpr/taste.png',
    title: 'Вміст смол, мг - 6\nВміст нікотину, мг - 0.5',
    position: 'top'
  },
  {
    id: 'filter',
    icon: 'images/mpmpr/filter.png',
    title:
      'Класичний ацетатний фільтр з високоякісної целюлози, який затримує тверді частинки сигаретного диму.',
    position: 'right'
  },
  {
    id: 'format',
    icon: 'images/mpmpr/format.png',
    title:
      'Формат – King Size ("Кінг сайз")\nКількість сигарет у пачці – 20\nКількість пачок у блоці – 10',
    position: 'bottom'
  }
];

const MenuScreen = ({ backgroundImage, title, setScreenNumber, partners }) => {
  const [openedSection, setOpenedSection] = useState(null);
  const [shiftDirection, setShiftDirection] = useState(null);
  const { sendEvent } = useContext(DataLayerEventContext);

  const menuButtons = [
    {
      id: 'difference',
      image: 'images/mpmpr/difference.png',
      text: 'Як відрізнити підробку від оригіналу?',
      handleClick: () => setScreenNumber(4)
    },
    {
      id: 'reviews',
      image: 'images/mpmpr/reviews.png',
      text: 'Залишити відгук про продукт',
      handleClick: () => setScreenNumber(7)
    },
    {
      id: 'quiz',
      image: 'images/mpmpr/quiz.png',
      text: '30 грн за витрачений час для опитування',
      handleClick: () => setScreenNumber(15)
    }
  ];

  const handleToggleSection = (sectionId, position) => {
    if (openedSection === sectionId) {
      setOpenedSection(null);
      setShiftDirection(null);
    } else {
      setOpenedSection(sectionId);
      setShiftDirection(position === 'right' ? 'right' : 'left');
    }
  };

  const handleCloseSection = () => {
    setOpenedSection(null);
    setShiftDirection(null);
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: backgroundImage }}
    >
      <p className={styles.productTitle}>{title}</p>
      <div className={styles.contentWrapper}>
        <div
          className={styles.packContainer}
          style={{ cursor: openedSection ? 'pointer' : 'default' }}
          onClick={openedSection ? handleCloseSection : undefined}
        >
          <div
            className={`${styles.packWrapper} ${
              openedSection && shiftDirection === 'left'
                ? styles.packShiftedLeft
                : ''
            } ${
              openedSection && shiftDirection === 'right'
                ? styles.packShiftedRight
                : ''
            }`}
          >
            <img
              src={getImageFromS3('/images/mpmpr/pack.png')}
              alt="pack"
              className={styles.packImage}
            />
            {!openedSection &&
              infoSections.map((section) => (
                <button
                  key={section.id}
                  className={`${styles.plusButton} ${
                    styles[
                      `plus${
                        section.position.charAt(0).toUpperCase() +
                        section.position.slice(1)
                      }`
                    ]
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToggleSection(section.id, section.position);
                  }}
                >
                  <img
                    src={getImageFromS3('/images/mpmpr/plus.png')}
                    alt="plus"
                    className={styles.plusIcon}
                  />
                </button>
              ))}
          </div>
          {infoSections.map((section) => (
            <div
              key={section.id}
              className={`${styles.infoContent} ${
                openedSection === section.id ? styles.infoVisible : ''
              } ${
                shiftDirection === 'right' ? styles.infoLeft : styles.infoRight
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={styles.iconWrapper}>
                <img src={getImageFromS3(section.icon)} alt={section.title} />
              </div>
              <div className={styles.textContent}>
                <p>{section.title}</p>
              </div>
            </div>
          ))}
        </div>
        <button
          className={styles.allAssortmentButton}
          onClick={() => setScreenNumber(3)}
        >
          Повний асортимент
        </button>
        <div className={styles.menuButtonsList}>
          {menuButtons.map((button) => (
            <button
              key={button.id}
              className={styles.menuButton}
              onClick={button.handleClick}
            >
              <div className={styles.menuButtonImage}>
                <img src={getImageFromS3(button.image)} alt={button.text} />
              </div>
              <span className={styles.menuButtonText}>{button.text}</span>
            </button>
          ))}
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>
            <b>Philip Morris Blue</b> можна знайти у роздрібних точках продажу в
            твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <button onClick={() => sendEvent('cig-poshta')}>
              <a href={partners ? partners.cig : ''}>Cig-poshta</a>
            </button>
            <button onClick={() => sendEvent('rozetka')}>
              <a href={partners ? partners.rozetka : ''}>Rozetka</a>
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <p>Куріння викликає серйозні</p>
        <p>захворювання та залежність</p>
        <p>Дана інформація про продукт надається</p>
        <p>
          відповідно до статті 15 Закону України «Про захист прав споживачів»
        </p>
      </div>
    </div>
  );
};

export default MenuScreen;
